import React, { FC } from 'react';
import InfoTool from 'public/icons/ag-icons/Information.svg';

interface Props {
  severity: string;
  message: string;
  className?: string;
}

const Message: FC<Props> = ({ severity, message, className = '' }) => {
  const classname = () => {
    if (severity === 'error') {
      return `bg-ag_color-error`;
    } else if (severity === 'success') {
      return `bg-ag_color-success`;
    } else if (severity === 'info') {
      return `bg-ag_color-info`;
    } else {
      return `bg-ag_color-warning`;
    }
  };

  return (
    <div
      className={`${classname()} relative mb-18 rounded-sm py-15 pl-50 pr-15 text-[12px] font-medium text-white ${className}`}
    >
      {severity === 'error' && (
        <span className="absolute top-1/2 ml-[-32px] -translate-y-1/2 text-24">
          <InfoTool />
        </span>
      )}
      {severity === 'info' && <i className="icon icon-trophy-1 absolute ml-[-32px] text-24 !font-light"></i>}
      {severity === 'warning' && <i className="icon icon-trophy-1 absolute ml-[-32px] text-24 !font-light"></i>}
      {severity === 'success' && <i className="icon icon-check absolute ml-[-32px] text-24 !font-light"></i>}
      <span>{message}</span>
    </div>
  );
};

export default Message;
